/* unplugin-vue-components disabled */import { render } from "./AfterValue.vue?vue&type=template&id=1f906e06"
import script from "./AfterValue.vue?vue&type=script&lang=js"
export * from "./AfterValue.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__